import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import SaasPaymentDueBanner from "./SaasPaymentDueBanner";
import { GET_CURRENT_USER_URL, HAI_READ_ONLY_GROUP } from "../utils/URLS";
import axios from "axios";
import { useUserContext } from "../Context/UserContext";
import { ChatAlertsProvider } from "../Context/ChatAlertsContext";
import LoadingSpinner from "./ui/LoadingSpinner";

export default function Layout({ children }) {
  const navigate = useNavigate();
  const [user, setUser] = useUserContext();
  const [loading, setLoading] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    if (!user) {
      const token = localStorage.getItem("token");
      const email = localStorage.getItem("email");

      if (token && email) {
        async function checkLogin() {
          try {
            const response = await axios.get(GET_CURRENT_USER_URL, {
              headers: {
                Authorization: `Token ${token}`,
              },
            });
            setUser(response.data);
            if (response.data.groups.includes("administrator")) {
              // navigate("/dashboard");
              if (pathname === "/") navigate("/dashboard");
              else navigate(pathname);
            } else {
              const isHaiReadOnly =
                !response.data.user?.is_superuser &&
                response.data.groups.includes(HAI_READ_ONLY_GROUP);
              if (pathname === "/")
                navigate(isHaiReadOnly ? "/org-hierarchy" : "/companies");
              else navigate(pathname);
            }
            setLoading(false);
          } catch (err) {
            if (err.response?.status === 401) {
              navigate("/signin");
            } else {
              navigate("/signin");
            }
          }
        }
        checkLogin();
      } else {
        navigate("/signin");
      }
    } else {
      setLoading(false);
    }

    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading ? (
        <div className="flex h-screen items-center justify-center">
          <LoadingSpinner />
        </div>
      ) : (
        <ChatAlertsProvider>
          <div className="flex min-h-screen grid-cols-[250px_1fr] bg-slate-100 md:grid-cols-[350px_1fr]">
            <Sidebar />
            <div className="flex flex-1 flex-col gap-8 p-8">
              <Header />
              <SaasPaymentDueBanner />
              <Outlet />
            </div>
          </div>
        </ChatAlertsProvider>
      )}
    </>
  );
}
